export default function Badge(props) {
    const { label, icon = false } = props
    return (
        <span className={`w-fit whitespace-nowrap inline-flex gap-1 items-center py-1 px-2 mr-2 text-xs font-medium rounded-lg text-indigo-800 bg-indigo-100`}>
            { icon } {label}
        </span>
    )
}